export enum ItemTypes {
  SERVICE = 'service',
  INVENTORY = 'inventory',
  NON_INVENTORY = 'non_inventory'
}
